import { actionInteractionModifyGeoJSONFeatures, featureToGeoJSONObject, reverseGeoJSONFeatureGeometry, } from '@tmapy/mapcore';
import { LAYER_IDS } from '@tmapy/config';
export const actionReverseLine = (payload) => async (dispatch) => {
    const editedLayerFeatures = payload.features.filter((layerFeature) => layerFeature.layerId === LAYER_IDS.EDIT_TOOLS_HIGHLIGHT);
    const editedOLFeature = editedLayerFeatures[0]?.feature;
    if (!editedOLFeature) {
        return;
    }
    const geoJSONFeature = featureToGeoJSONObject(editedOLFeature);
    dispatch(actionInteractionModifyGeoJSONFeatures(LAYER_IDS.EDIT_TOOLS_HIGHLIGHT, [
        reverseGeoJSONFeatureGeometry(geoJSONFeature),
    ]));
};
//# sourceMappingURL=reverseLine.js.map